import { useState, useRef, useEffect, useLayoutEffect } from 'react';

export default function ActionsDropdown({ actions }) {
  const [open, setOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const ref = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useLayoutEffect(() => {
    if (!open || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const menuHeightEstimate = actions.length * 38 + 12;
    const spaceBelow = window.innerHeight - rect.bottom;
    setOpenUpward(spaceBelow < menuHeightEstimate && rect.top > menuHeightEstimate);
  }, [open, actions.length]);

  return (
    <div className="actions-dropdown" ref={ref}>
      <button className="btn btn-secondary" onClick={() => setOpen(o => !o)}>
        Actions ▾
      </button>
      {open && (
        <div ref={menuRef} className={'actions-dropdown-menu' + (openUpward ? ' open-upward' : '')}>
          {actions.map((a, i) => (
            <button key={i} onClick={() => { setOpen(false); a.onClick(); }} disabled={a.disabled}>
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
